module.exports = __webpack_public_path__ + "img/bikered.07357d5f.png";